<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import * as echarts from 'echarts';
	import JsPDF from 'jspdf'
	import html2Canvas from 'html2canvas'
	import minhead from '../../../../common/minHead/index.vue'
	import RiskReport from '../../../mapsUtil/RiskReport/index.vue';
	import {
		saveReporting,
	} from "../../../../../api/ReportEditor.js"
	import {
		Loading
	} from 'element-ui'
	export default {
		props: {
			DaqntTa: {
				type: Object,
				default: {}
			},
			isYl: {
				default: false
			},
		},
		components: {
			minhead,
			RiskReport
		},
		data() {
			return {
				FxzcGk: [],
				isfxiN: "低",
				vuea: "",
				riskIndex: [],
				measures: ["ReportRisk.companyCode1"],
				result: [],
				MuLuData: [{
					name: '风险总体概括',
					hang: "I"
				}, {
					name: '专项检查报告',
					hang: "II",
					XiaoMuluData: [{
						name: "税负率指标",
						Yem: "04"
					}, {
						name: "销售指标",
						Yem: "06"
					}, {
						name: "存货指标",
						Yem: "07"
					}, {
						name: "预收账款指标",
						Yem: "08"
					}, {
						name: "期间费用指标",
						Yem: "10"
					}, {
						name: "其他",
						Yem: "11"
					}, {
						name: "灰名单管理",
						Yem: "15"
					}, ]
				}],
				reportings: []
			}
		},
		created() {
			
			// this.measures = [this.DaqntTa.companyCode]
			//本次模型命中情况
			this.result = [];
			// 遍历所有 modeType 类型
			const modeTypes = [...new Set(this.DaqntTa.smwds.map(item => item.modeType))];
			modeTypes.forEach(modeType => {
				// 筛选 modeType 相同的数据
				const modeTypeData = this.DaqntTa.smwds.filter(item => item.modeType === modeType);
				this.result.push({
					modeType,
					data: modeTypeData
				});
			});


			//目录
			this.MuLuData[1].XiaoMuluData = [];
			let shu = 4;
			const smwds = [...new Set(this.DaqntTa.reportings.map(item => item.smwd))];
			let zhansc = 0;
			this.reportings = []
			smwds.forEach((smwd, index) => {
				// 筛选 modeType 相同的数据
				const smwdsData = this.DaqntTa.reportings.filter(item => item.smwd === smwd);
				this.reportings = [...this.reportings, ...smwdsData]
				if (index == 0) {
					shu += 1
					zhansc = smwdsData.length;
				} else {
					shu += zhansc;
					zhansc = smwdsData.length;
				}
				this.MuLuData[1].XiaoMuluData.push({
					name: smwd,
					Yem: shu < 10 ? "0" + shu : shu
				});
			});
			//图表分析
			this.riskIndex = []
			this.reportings.map(v => {
				this.riskIndex.push([v.riskIndexCode])
			})
			//风险总体概况
			this.FxzcGk = [];
			for (let var1 in this.DaqntTa.categoryMap) {
				this.FxzcGk.push({
					name: var1,
					Suoming: this.DaqntTa.categoryMap[var1]
				})
			}

		},
		mounted() {},
		methods: {
			//表格隐藏显示和返回
			forback() {
				this.$emit('forback', true);
			},
			kangq() {
				console.log(this.DaqntTa)
				saveReporting(this.DaqntTa).then(res => {
					if (res.data.code == 1) {
						this.$message.success('保存成功')
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			baocdaykangq() {
				saveReporting(this.DaqntTa).then(res => {
					if (res.data.code == 1) {
						this.$message.success('保存成功开始生成PDF!')

						var loading = Loading.service({
							lock: true,
							text: 'PDF导出中，请稍等',
							background: 'rgba(0, 0, 0, 0.7)'
						})
						let Iddui = 4 + this.DaqntTa.reportings.length;
						let Idlist = [];
						for (let i = 0; i < Iddui; i++) {
							Idlist.push(i)
						}
						setTimeout(() => {
							this.$nextTick(() => {
								this.htmlToPdf(Idlist.join(','), this
									.DaqntTa.companyName + '的风险报告')
							})
						}, 3500)

					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>